import React, { useState, useEffect, useRef } from "react"
import { TaskTable } from "../../screen/ActionTableScreen"
import moment from "moment"
import "moment/locale/pt-br"
import { customToast } from "../../components/Toast"
import Send from "../../core/communication"
import { useScope } from "../../container/SelectProjectCompanyContainer"
import { getIds } from "../../core/utils/getIds"
import { useParams } from "react-router-dom"
import { useSelector } from "react-redux"
moment.locale("pt-br")

const loadAllTec = async (setTechnicalList, scopeType, projectsByScope) => {
  const formattedProjectsByScope = projectsByScope.map((row) => ({
    value: row?.id,
    label: row?.description,
  }))

  try {
    const response = await Send.get(
      "/users/tec-or-manager",
      `projects=${getIds(formattedProjectsByScope)}&scopeType=${scopeType}&role=manager`,
    )
    setTechnicalList(response.map((row) => ({ value: row?.id, label: row?.name })))
  } catch (error) {
    console.log("Error => ", error)
    customToast("Erro ao carregar técnicos", "error")
  }
}

export const TaskTableContainer = ({
  data,
  tagPossibility,
  setTagPossibility,
  loadingActionPlan,
  selectedIndicator,
  uniqueEmails,
  fromUsers,
  exportPlan = () => { },
  reload = () => { },
  isAssistanceScreen,
  showActions = true,
  changeFilter = () => { },
  filter = {},
  handleActiveIndicator,
  formSteps,
  indicatorTabsOptions,
  indicators
}) => {
  const { userId } = useParams()
  const { user } = useSelector(state => state?.app?.user)
  const role = user?.roles.role
  const { scope, scopeType, projectsByScope } = useScope()
  const [loadingActionSave, setLoadingActionSave] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  const [values, setValues] = useState({})
  const [internalData, setData] = useState([])
  const [technicalList, setTechnicalList] = useState([])
  const [modalFilterIsOpen, setModalFilterIsOpen] = useState(false)
  const [openModalComment, setOpenModalComment] = useState(false)
  const [loadingSaveComments, setLoadingSaveComments] = useState(false)
  const [actionId, setActionId] = useState("")
  const [commentEdit, setCommentEdit] = useState(null)
  const [projects, setProjects] = useState([])

  useEffect(() => {
    if (typeof data === "object") {
      setData(data)
    }
  }, [data])

  useEffect(() => {
    if (scope?.id) {
      loadAllTec(setTechnicalList, scopeType, projectsByScope)
    }
  }, [scope])

  const hasInitialized = useRef(false)

  useEffect(() => {
    if (!hasInitialized.current && Array.isArray(data) && data.length > 0 && !userId) {
      const projecttData = data.map(({ project }) => ({ label: project, value: project }))
      const projects = _.uniqBy(projecttData, "value")
      setProjects(projects)
      hasInitialized.current = true
    }
  }, [data, userId])

  const onChangeValues = (event) => {
    const { value, name } = event.target
    console.log("event -> ", { value, name })
    setValues((curr) => ({ ...curr, [name]: value }))
  }

  const handleCloseModalComment = () => {
    setActionId(null)
    setOpenModalComment(false)
    setCommentEdit(null)
    setValues({})
  }

  const handleOpenModalComment = (id) => {
    setActionId(id)
    setOpenModalComment(true)
  }

  const handleModalOpenEdit = (value) => {

    const {
      actionId,
      title,
      location,
      internal_responsible,
      external_responsible,
      start_at,
      finish_at,
      why,
      who,
      instructions,
      indicatorId,
      reviewerId,
      producerId,
      comments,
      creatorName,
      projectId
    } = value
    setModalOpen(true)

    setValues({
      actionId,
      title,
      location,
      internal_responsible,
      external_responsible,
      indicatorId,
      start_at,
      finish_at,
      why,
      who,
      instructions,
      reviewerId,
      producerId,
      comments,
      creatorName,
      projectId
    })
  }

  const handleUpdateAction = async () => {
    try {
      setLoadingActionSave(true)

      const dataToUpdate = {
        title: values?.title,
        reviewer: values?.reviewer?.value,
        selectedIndicator: selectedIndicator || values?.indicatorId,
        projectId: values?.projectId || fromUsers?.projectId || scope?.id,
        details: {
          email: values?.internal_responsible,
          external_responsible: values?.external_responsible,
          finish_at: values?.finish_at || moment().format("YYYY-MM-DD"),
          start_at: values?.start_at || moment().format("YYYY-MM-DD"),
          location: values?.location,
          why: values?.why,
          instructions: values?.instructions,
        },
        producerId: values?.producerId,
      }

      const response = await Send.put(
        `/scale-action/farmer-profile/action/${values?.actionId}`,
        dataToUpdate,
      )

      if (response?.status !== "success") {
        customToast(`${response?.message}`, "error")
        return
      }

      customToast("Ação alterada com sucesso", "success")
      setModalOpen(false)
    } catch (error) {
      console.log("Error ", error)
      customToast("Erro ao alterar ação", "error")
    } finally {
      setLoadingActionSave(false)
      reload()
    }
  }

  const handleCreateComment = async () => {

    try {
      setLoadingSaveComments(true)

      const dataToUpdate = {
        message: values?.comments,
        author: user?.email
      }

      const response = await Send.put(
        `/scale-action/action/${actionId}/comment`,
        dataToUpdate,
      )

      if (response?.status !== "success") {
        customToast(`${response?.message}`, "error")
        return
      }

      setLoadingSaveComments(false)
      reload()
    } catch (error) {
      customToast("Erro ao criar comentário", "error")

    }
    finally {
      setLoadingSaveComments(false)
      handleCloseModalComment()
    }

  }

  const handleDeleteComment = async (id, actionId) => {
    try {
      setLoadingSaveComments(true)

      const response = await Send.delete(
        `/scale-action/action/${actionId}/comment/${id}`
      )

      if (response?.status !== "success") {
        customToast(`${response?.message}`, "error")
        return
      }

      customToast(`${response?.message}`, "success")

      reload()
    } catch (error) {
      customToast("Erro ao excluir comentário", "error")
    }
  }

  const handleUpdateComment = async () => {
    try {
      setLoadingSaveComments(true)

      const dataToUpdate = {
        message: values?.comments,
      }

      const response = await Send.put(
        `/scale-action/action/${actionId}/comment/${commentEdit?.id}`,
        dataToUpdate,
      )

      if (response?.status !== "success") {
        customToast(`${response?.message}`, "error")
        return
      }

      setLoadingSaveComments(false)
      reload()
    } catch (error) {
      customToast("Erro ao criar comentário", "error")

    }
    finally {
      setLoadingSaveComments(false)
      handleCloseModalComment()
    }
  }

  const handleEditComment = (item, actionId) => {
    setCommentEdit(item)
    setActionId(actionId)
    setValues({
      comments: item?.message
    })
    setOpenModalComment(true)
  }

  const handleDeleteAction = async (action) => {
    try {
      const response = await Send.delete(`/scale-action/${action?.actionId}`)

      if (response?.status !== 'success') {
        customToast(response?.message, "error")
        return
      }

      customToast(response?.message, "success")
      reload()
    } catch (error) {
      const errorMessage = error?.message || "Erro ao excluir a ação"
      console.error(errorMessage)
      customToast(errorMessage, "error")
    }
  }

  const handleCompleteAction = async (value, actionProducerId, status) => {
    try {
      const response = await Send.put(`/scale-action-producer/${actionProducerId}`, {
        status: value?.value,
      })

      if (response?.id) {
        setData((old) =>
          old?.map((row) =>
            row?.actionProducerId === response.id ? { ...row, status: response?.status } : row,
          ),
        )
        customToast("Status da ação alterado.", "success")
      }

      reload()
    } catch (error) {
      console.log("Error", error)
      customToast("Erro ao alterar status da ação", "error")
    }
  }

  const changeTag = async (value, isNew, item) => {
    const oldTags = typeof item.tags === "string" ? JSON.parse(item.tags) : item.tags
    if (item?.actionProducerId) {
      try {
        const response = await Send.put(`/scale-action-producer/${item?.actionProducerId}`, {
          tags: JSON.stringify(
            oldTags.includes(value)
              ? oldTags.filter((row) => row !== value)
              : oldTags.concat(value),
          ),
        })

        if (response?.id && response?.tags) {
          setData((old) =>
            old.map((row) =>
              row.actionProducerId === response.id ? { ...row, tags: response.tags } : row,
            ),
          )
          if (isNew) {
            setTagPossibility((old) => old.concat(value))
          }
          customToast(
            item.tags.includes(value) ? "Tag removida da ação" : "Tag adicionada a ação.",
            "success",
          )
        }
      } catch (error) {
        console.log("Error", error)
        customToast("Erro ao adicionar tag", "error")
      }
    }
  }

  return (
    <TaskTable
      {...{
        handleCompleteAction,
        handleOpenModalComment,
        changeTag,
        tagPossibility,
        changeFilter,
        filter,
        uniqueEmails,
        exportPlan,
        data: internalData,
        loadingActionSave,
        isAssistanceScreen,
        loadingActionPlan,
        handleModalOpenEdit,
        handleDeleteAction,
        handleUpdateAction,
        modalOpen,
        setModalOpen,
        values,
        onChangeValues,
        showActions,
        formSteps,
        indicatorTabsOptions,
        indicators,
        technicalList,
        handleActiveIndicator,
        modalFilterIsOpen,
        setModalFilterIsOpen,
        userId,
        handleCreateComment,
        handleUpdateComment,
        handleCloseModalComment,
        openModalComment,
        setOpenModalComment,
        loadingSaveComments,
        handleEditComment,
        handleDeleteComment,
        commentEdit,
        projects
      }}
    />
  )
}
